module.exports = __webpack_public_path__ + "static/b6-8bfe4fc902ebdaffa33eb02ab699040b.jpg";